import { createContext, useContext, useTransition } from 'react';

const OfferReviewLoadingContext = createContext<{
  isPending: boolean;
  startTransition: (callback: () => void) => void;
}>({
  isPending: false,
  startTransition: () => {
    // no-op
  },
});

export const OfferReviewLoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const [isPending, startTransition] = useTransition();

  return (
    <OfferReviewLoadingContext.Provider value={{ isPending, startTransition }}>
      {children}
    </OfferReviewLoadingContext.Provider>
  );
};

export const useOfferReviewLoadingContext = () => useContext(OfferReviewLoadingContext);
